import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { User, Tokens } from '../types'

/** Původní přihlášení administrátora, uschované po dobu režimu „Přihlásit se jako jiný uživatel". */
export interface Impersonator {
  user: User
  tokens: Tokens
}

interface AuthState {
  user: User | null
  tokens: Tokens | null
  isAuthenticated: boolean
  /** Neprázdné = běží impersonace; `user`/`tokens` pak patří cílovému uživateli. */
  impersonator: Impersonator | null
  setAuth: (user: User, tokens: Tokens) => void
  setTokens: (tokens: Tokens) => void
  startImpersonation: (user: User, tokens: Tokens) => void
  stopImpersonation: () => void
  logout: () => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      tokens: null,
      isAuthenticated: false,
      impersonator: null,
      setAuth: (user, tokens) =>
        set({
          user,
          tokens,
          isAuthenticated: true,
        }),
      setTokens: (tokens) =>
        set({
          tokens,
        }),
      startImpersonation: (user, tokens) => {
        const { user: currentUser, tokens: currentTokens, impersonator } = get()
        // Žádné vnořování — z impersonace se nejdřív musí odejít zpět k adminovi.
        if (impersonator || !currentUser || !currentTokens) return
        set({
          impersonator: { user: currentUser, tokens: currentTokens },
          user,
          tokens,
          isAuthenticated: true,
        })
      },
      stopImpersonation: () => {
        const { impersonator } = get()
        if (!impersonator) return
        set({
          user: impersonator.user,
          tokens: impersonator.tokens,
          impersonator: null,
          isAuthenticated: true,
        })
      },
      logout: () =>
        set({
          user: null,
          tokens: null,
          isAuthenticated: false,
          impersonator: null,
        }),
    }),
    {
      name: 'das-auth',
    }
  )
)
